import { css } from 'styled-components';

const media = {
  phone: (...args) => css`
    @media (max-width: 500px) {
      ${ css(...args) }
    }
  `
};

export {
  media
};



// WEBPACK FOOTER //
// ./src/styles-helper.js